import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { refreshPermissions } from '../../redux/modules/cuenta/login';

/**
 * Hook para refrescar permisos automáticamente mediante polling
 * @param {number} intervalSeconds - Intervalo en segundos para refrescar (default: 30)
 */
export const usePermissionPolling = (intervalSeconds = 30) => {
    const dispatch = useDispatch();
    const me = useSelector(state => state.login.me);
    const intervalRef = useRef(null);
    const isActiveRef = useRef(true);

    useEffect(() => {
        // Solo hacer polling si el usuario está autenticado
        if (!me || !me.id) {
            return;
        }

        // Hacer un refresh inicial inmediatamente al montar
        console.log('[Permission Polling] Starting permission polling for user:', me.id);
        dispatch(refreshPermissions());

        // Detectar si la pestaña está activa/inactiva
        const handleVisibilityChange = () => {
            isActiveRef.current = !document.hidden;

            // Si la pestaña vuelve a estar activa, refrescar inmediatamente
            if (isActiveRef.current) {
                console.log('[Permission Polling] Tab became active, refreshing permissions');
                dispatch(refreshPermissions());
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        // Configurar intervalo de polling
        const intervalMs = intervalSeconds * 1000;
        console.log(`[Permission Polling] Setting up polling every ${intervalSeconds} second(s)`);

        intervalRef.current = setInterval(() => {
            // Solo hacer polling si la pestaña está activa
            if (isActiveRef.current) {
                dispatch(refreshPermissions());
            }
        }, intervalMs);

        // Cleanup
        return () => {
            console.log('[Permission Polling] Cleaning up permission polling');
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [dispatch, me, intervalSeconds]);
};
